"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DELETE_PROPOSAL = void 0;
const gql_1 = require("../../../__generated__/gql");
exports.DELETE_PROPOSAL = (0, gql_1.gql)(`
   mutation DeleteProposal($proposal: DeleteProposalInput!) {
  deleteProposal(proposal: $proposal) {
    error
    success
  }
}`);
